import { useContext, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { capitalize } from "../Form/Form";
import { FarmContext } from "../../contexts/FarmContext";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { Dialog } from "primereact/dialog";


const ReportDetailDialog = ({ dialogState, setDialogState, sectorsInfo, fields }) => {
    const { t } = useTranslation();
    const dialogRef = useRef(null);
    const [_, dispatch] = useContext(FarmContext);
    const pumpsys = dispatch({ type: "get", path: "pumpsys" });

    const equiposData = useMemo(() => {
        if (pumpsys && dialogState?.reporte?.equipos?.length > 0){
            return pumpsys.filter(p => dialogState.reporte.equipos.includes(p.equipo_id));
            
        }
        return []
    }, [dialogState.reporte.equipos, pumpsys])

    const sectoresData  = useMemo(() => {
        if (sectorsInfo && dialogState?.reporte?.sectores?.length > 0){
            return sectorsInfo.filter(s => dialogState.reporte.sectores.includes(s.sector_id));
        }
        return []
    }, [dialogState.reporte.sectores, sectorsInfo])

    const camposData  = useMemo(() => {
        if (fields && dialogState?.reporte?.campos?.length > 0){
            return fields.filter(f => dialogState.reporte.campos.includes(parseInt(f.id.split("-")[1], 10)));
        }
        return []
    }, [dialogState.reporte.campos, fields])

    return (
        <Dialog
            id='dialogBitacora'
            className='dialog-prime'
            transitionOptions={{ effect: 'Zoom', duration: 300, delay: 0 }}
            baseZIndex={1040}
            visible={dialogState?.visible}
            onHide={() => setDialogState({ visible: false })}
            style={{width:'600px'}}
            ref={dialogRef}
            closable={true}
            header={t("systemEvents.table.detalle")}>
        <div>
            <div>
                {
                    dialogState.reporte?.configuracion.destinatarios &&
                    <div className="mb-4">
                        <DataTablePrime
                            t={t}
                            items={[dialogState.reporte.configuracion.destinatarios].flat().map(s => ({ destinatario: s }))}
                            size="small"
                            fields={[
                                {field:"destinatario",header:t("farms.pozo.reportesEmails"), bodyStyle:{textAlign:"center"}},
                            ]}
                        />
                    </div>
                }
                {
                    Boolean(equiposData?.length) &&
                    <div className="mb-4">
                        <DataTablePrime
                            t={t}
                            items={equiposData}
                            size="small"
                            fields={[
                                {field:"nombre",header:capitalize(t("farms.etiqueta.equipos")), bodyStyle:{textAlign:"center"}},
                            ]}
                        />
                    </div>
                }
                {
                    Boolean(sectoresData?.length) &&
                    <div className="mb-4">
                        <DataTablePrime
                            t={t}
                            items={sectoresData}
                            size="small"
                            fields={[
                                {field:"nombre",header:t("farms.zonesTable.title"), bodyStyle:{textAlign:"center"}},
                            ]}
                        />
                    </div>
                }
                {
                    Boolean(camposData?.length) &&
                    <div className="mb-4">
                        <DataTablePrime
                            t={t}
                            items={camposData}
                            size="small"
                            fields={[
                                {field:"name",header:t("farms.farms"), bodyStyle:{textAlign:"center"}},
                            ]}
                        />
                    </div>
                }
            </div>
        </div>
        </Dialog>
    )
}

export { ReportDetailDialog }